import React from "react";
import { Col, Form, Input, Row } from "antd";
import TextArea from "antd/es/input/TextArea";

export const PrimaryUserInfoComponent = ({
    mobile,
    setMobile,
    tel,
    setTel,
    address,
    setAddress,
    postalCode,
    setPostalCode
}) => {

    return (
        <>
            <div className="sectionTitle">
                <h2>اطلاعات تکمیلی سرپرست</h2>
            </div>

            <div className="container">

                <Form
                    layout="vertical"
                    requiredMark={false}
                >

                    <Row gutter={16}>

                        <Col xs={24} md={8}>
                            <Form.Item
                                label="شماره موبایل"
                                required
                                validateStatus={
                                    !mobile
                                        ? "error"
                                        : mobile && !/^09\d{9}$/.test(mobile)
                                            ? "error"
                                            : ""
                                }
                                help={
                                    !mobile
                                        ? "شماره موبایل الزامی است."
                                        : mobile && !/^09\d{9}$/.test(mobile)
                                            ? "شماره موبایل معتبر نیست."
                                            : ""
                                }
                            >
                                <Input
                                    value={mobile}
                                    maxLength={11}
                                    placeholder="09123456789"
                                    style={{ textAlign: "left", direction: "ltr" }}
                                    onChange={(e) =>
                                        setMobile(
                                            e.target.value.replace(/[^\d]/g, "")
                                        )
                                    }
                                />
                            </Form.Item>
                        </Col>

                        <Col xs={24} md={8}>
                            <Form.Item
                                label="تلفن ثابت"
                            >
                                <Input
                                    value={tel}
                                    placeholder="02112345678"
                                    style={{ textAlign: "left", direction: "ltr" }}
                                    onChange={(e) =>
                                        setTel(
                                            e.target.value.replace(/[^\d]/g, "")
                                        )
                                    }
                                />
                            </Form.Item>
                        </Col>

                        <Col xs={24} md={8}>
                            <Form.Item
                                label="کد پستی"
                                validateStatus={
                                    postalCode &&
                                        !/^\d{10}$/.test(postalCode)
                                        ? "error"
                                        : ""
                                }
                                help={
                                    postalCode &&
                                        !/^\d{10}$/.test(postalCode)
                                        ? "کد پستی باید ۱۰ رقم باشد."
                                        : ""
                                }
                            >
                                <Input
                                    value={postalCode}
                                    maxLength={10}
                                    placeholder="کد پستی"
                                    style={{ textAlign: "left", direction: "ltr" }}
                                    onChange={(e) =>
                                        setPostalCode(
                                            e.target.value.replace(/[^\d]/g, "")
                                        )
                                    }
                                />
                            </Form.Item>
                        </Col>

                    </Row>

                    <Form.Item
                        label="آدرس"
                        required
                        validateStatus={
                            !address
                                ? "error"
                                : address.trim().length < 8
                                    ? "error"
                                    : ""
                        }
                        help={
                            !address
                                ? "آدرس الزامی است."
                                : address.trim().length < 8
                                    ? "آدرس باید حداقل ۸ کاراکتر باشد."
                                    : ""
                        }
                    >
                        <TextArea
                            rows={4}
                            value={address}
                            placeholder="آدرس کامل"
                            onChange={(e) => setAddress(e.target.value)}
                        />
                    </Form.Item>

                </Form>

            </div>
        </>
    );
};

// import { Col, Input, Row } from 'antd'
// import TextArea from 'antd/es/input/TextArea'
// import React from 'react'


// export const PrimaryUserInfoComponent = ({ setLoading, showMessage, mobile, setMobile, tel, setTel, address, setAddress ,postalCode,setPostalCode}) => {
//     return (
//         <>
//             <div className='sectionTitle'>
//                 <h2 >
//                     اطلاعات تکمیلی سرپرست
//                 </h2>
//             </div>
//             <div className='container'>

//                 <Row justify='center' style={{ borderBottom: '1px solid #cdcdcd', paddingTop: '8px', paddingBottom: '8px' }}>

//                     <Col xs={6} sm={6} md={6} lg={2} xl={2} >
//                         <div className='primary-info-title'>شماره موبایل:</div>
//                     </Col>
//                     <Col xs={18} sm={18} md={18} lg={5} xl={5} >
//                         <Input className='primary-info-value' placeholder="شماره موبایل" value={mobile} onChange={(e) => { setMobile(e.target.value) }} style={{ width: '100%', textAlign: 'center' }} />
//                     </Col>
//                     <Col xs={24} sm={24} md={24} lg={1} xl={1} >
//                     </Col>
//                     <Col xs={6} sm={6} md={6} lg={2} xl={2} >
//                         <div className='active-info-title'>تلفن ثابت:</div>
//                     </Col>
//                     <Col xs={18} sm={18} md={18} lg={5} xl={5} >
//                         <Input className='primary-info-value' placeholder="تلفن ثابت" value={tel} onChange={(e) => { setTel(e.target.value) }} style={{ width: '100%', textAlign: 'center' }} />
//                     </Col>
//                     <Col xs={24} sm={24} md={24} lg={1} xl={1} >
//                     </Col>
//                     <Col xs={6} sm={6} md={6} lg={2} xl={2} >
//                         <div className='primary-info-title'>کد پستی:</div>
//                     </Col>
                
//                     <Col xs={18} sm={18} md={18} lg={5} xl={5} >
//                         <Input className='primary-info-value' placeholder="کدپستی" value={postalCode} onChange={(e) => { setPostalCode(e.target.value) }} style={{ width: '100%', textAlign: 'center' }} />
//                     </Col>
                
//                 </Row>


//                 <Row justify='center' style={{ borderBottom: '1px solid #cdcdcd', paddingTop: '8px', paddingBottom: '8px' }}>
//                     <Col xs={6} sm={6} md={6} lg={3} xl={2} >
//                         <div className='primary-info-title'>آدرس:</div>
//                     </Col>
//                     <Col xs={18} sm={18} md={18} lg={5} xl={21} >
//                         <TextArea className='primary-info-value' rows={4} placeholder="آدرس" value={address} onChange={(e) => { setAddress(e.target.value) }} style={{ width: '100%' }} />
//                     </Col>
//                 </Row>
//                 { }
//             </div>
//         </>

//     )
// }